import { FieldTemplate, FieldType } from 'api/models/FieldTemplate';
import { useTranslation } from 'react-i18next';
export default function usePatientFieldsMap() {
  const { t } = useTranslation();
  const patientFielData = [
    {
      label: 'idTaj',
      type: FieldType.StringList,
    },
    {
      label: 'idOther',
      type: FieldType.StringList,
    },
    {
      label: 'patientProjectId',
      type: FieldType.StringList,
    },
    {
      label: 'titles',
      type: FieldType.Text,
    },
    {
      label: 'lastName',
      type: FieldType.Text,
    },
    {
      label: 'firstName',
      type: FieldType.Text,
    },
    {
      label: 'gender',
      type: FieldType.Select,
      options: [
        {
          value: 'female',
          label: t(`general.female`),
        },
        {
          value: 'male',
          label: t(`general.male`),
        },
        {
          value: 'other',
          label: t(`general.other`),
        },
      ],
    },
    {
      label: 'birthDate',
      type: FieldType.Date,
    },
    {
      label: 'isDead',
      type: FieldType.Select,
      options: [
        {
          value: 'true',
          label: t(`general.yes`),
        },
        {
          value: 'false',
          label: t(`general.no`),
        },
      ],
    },
    {
      label: 'deathDate',
      type: FieldType.Date,
    },
    {
      label: 'birthFirstName',
      type: FieldType.Text,
    },
    {
      label: 'birthLastName',
      type: FieldType.Text,
    },
    {
      label: 'motherFirstName',
      type: FieldType.Text,
    },
    {
      label: 'motherLastName',
      type: FieldType.Text,
    },
    {
      label: 'addressPostcode',
      type: FieldType.Text,
    },
    {
      label: 'addressCity',
      type: FieldType.Text,
    },
    {
      label: 'addressStreet',
      type: FieldType.Text,
    },
    {
      label: 'addressHouseNumber',
      type: FieldType.Text,
    },
    {
      label: 'phoneNumber',
      type: FieldType.Text,
    },
    {
      label: 'email',
      type: FieldType.Text,
    },
    {
      label: 'notes',
      type: FieldType.Text,
    },
  ];

  const patientFieldTemplates: FieldTemplate[] = patientFielData.map(field => {
    return {
      id: field.label,
      fieldType: field.type,
      alias: `patient.${field.label}`,
      version: -1,
      fieldAttributes: {
        label: t(`projectCreation.availablePatientFields.${field.label}`),
        type: field.type,
        options: field.options,
      },
    };
  });

  return new Map<string, FieldTemplate>(
    patientFieldTemplates.map(field => [field.id, field]),
  );
}
